import { get, put, del, post } from '@/services/http';

export class InventoryTransferRouteModel {
  public id?: number;
  public sourceLocationId: number;
  public destinationLocationId: number;
  public leadTimeDays: number;
  public priority: number;
  public isActive: boolean;
  public createdAt?: string;
  public updatedAt?: string;

  constructor(data: any = {}) {
    this.id = data.id;
    this.sourceLocationId = data.sourceLocationId;
    this.destinationLocationId = data.destinationLocationId;
    this.leadTimeDays = data.leadTimeDays;
    this.priority = data.priority;
    this.isActive = data.isActive === undefined ? true : data.isActive;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
  }

  public async fetch() {
    if (!this.id) { throw new Error('ID is required to fetch a transfer route.'); }
    const res: any = await get(`/inventory-transfer-routes/${this.id}`);
    this.mapData(res.data);
  }

  public mapData(data: any = {}) {
    this.id = data.id;
    this.sourceLocationId = Number(data.source_location_id);
    this.destinationLocationId = Number(data.destination_location_id);
    this.leadTimeDays = data.lead_time_days;
    this.priority = data.priority;
    this.isActive = data.is_active;
    this.createdAt = data.created_at;
    this.updatedAt = data.updated_at;
  }

  public toJSON() {
    return {
      id: this.id,
      source_location_id: String(this.sourceLocationId),
      destination_location_id: String(this.destinationLocationId),
      lead_time_days: this.leadTimeDays,
      priority: this.priority,
      is_active: this.isActive,
    };
  }

  public async save() {
    if (this.id) {
      await this.update();
    } else {
      await this.create();
    }
  }

  public async remove() {
    if (!this.id) { throw new Error('ID is required to delete a transfer route.'); }
    await del(`/inventory-transfer-routes/${this.id}`);
  }

  private async create() {
    const res: any = await post('/inventory-transfer-routes', this.toJSON());
    this.mapData(res);
  }

  private async update() {
    if (!this.id) { throw new Error('ID is required to update a transfer route.'); }
    const res: any = await put(`/inventory-transfer-routes/${this.id}`, this.toJSON());
    this.mapData(res);
  }
}
